import type { FC } from 'react';

import { FilterProvider } from 'src/components/app/context/FilterContext';
import type { PageFrameProps } from 'src/components/common/PageFrame';
import PageFrame from 'src/components/common/PageFrame';
import ReportOverview from 'src/components/report/CustomReportsPage/components/ReportOverview';
import { ShoppingCartProvider } from 'src/components/report/ShoppingCartContext';

export interface CustomReportsProps extends PageFrameProps {}

export const CustomReportsPage: FC<CustomReportsProps> = ({ ...props }) => (
  <PageFrame {...props}>
    <ReportOverview />
  </PageFrame>
);

// Wrap this page in a separate FilterProvider as its call of the useOrgTreeState-hook would run into racing conditions
// with the global initialization of the PlanActionContext and its call of the useOrgTreeState-hook.
const CustomReportsPageWrapper: FC<CustomReportsProps> = ({ ...props }) => (
  <FilterProvider>
    <ShoppingCartProvider>
      <CustomReportsPage {...props} />
    </ShoppingCartProvider>
  </FilterProvider>
);

export default CustomReportsPageWrapper;
